import React, { useState } from 'react'
import Player from './Player'
import { connect } from 'react-redux'
import { togglePlayer } from '../actions'

const ZedPlayer = (props) => {

  // const [ visible, setVisible ] = useState(true)
  const { visible } = props;
  const toggle = (action = null) => {
    const { dispatch } = props
    // setVisible( prevState => (
    //   !prevState
    // ))
    dispatch(togglePlayer())
    // if(action==='show') {
    //   setVisible('block')
    // } else {
    // }

  }

  return (
    <div id="ZP">
    <div id="zed-player">
      <span className="toggle" onClick={toggle}>{!visible ? <i className="fa fa-chevron-up" aria-hidden="true"></i> : <i className="fa fa-chevron-down" aria-hidden="true"></i> }</span>
      <Player visible={false} />
    </div>
    </div>
  )
}
export default connect(state => state.player)(ZedPlayer)
